import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { FaDollarSign, FaMoneyBillAlt, FaArrowUp, FaArrowDown } from 'react-icons/fa';
import * as XLSX from 'xlsx';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const FinancialReport = ({ financialData }) => {
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const monthlySales = months.map((month, index) => {
        const data = financialData?.general_financial_reports?.monthlySales?.find(item => parseInt(item?.month?.split('-')[1]) === index + 1);
        return data ? parseFloat(data.totalSales) : 0;
    });

    const monthlyExpenses = months.map((month, index) => {
        const data = financialData?.general_financial_reports?.monthlyExpenses?.find(item => parseInt(item?.month?.split('-')[1]) === index + 1);
        return data ? parseFloat(data.totalSales) : 0;
    });

    const exportToExcel = () => {
        const ws = XLSX.utils.aoa_to_sheet([
            ['Month', 'Total Sales', 'Total Expenses'],
            ...months.map((month, index) => [
                month,
                monthlySales[index],
                monthlyExpenses[index]
            ])
        ]);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Financial Report');

        XLSX.writeFile(wb, 'financial_report.xlsx');
    };

    return (
        <div className="w-full">
            <div className="flex justify-between mb-4">
                <p className="font-medium text-primary text-[20px]">Sales & expenses</p>
                <button
                    onClick={exportToExcel}
                    className="bg-primary text-white px-4 py-1.5 text-[13px] font-light rounded-md hover:bg-blue-700 transition duration-200"
                >
                    Export
                </button>
            </div>

            <div className="flex w-full flex-col md:flex-row mb-2 gap-3">
                <div className="bg-gradient-to-r from-green-200 to-green-50 p-6 rounded-lg flex items-start w-full justify-between ">
                    <div>
                        <h3 className="text-xl text-gray-600 mb-2">Total Sales</h3>
                        <p className="text-[20px] font-semibold text-green-600">
                            {`Kes. ${financialData?.general_financial_reports?.totalSales?.toLocaleString()}`}
                        </p>
                    </div>
                    <div className="bg-green-200 p-2 rounded-full border border-green-500">
                        <FaDollarSign size={24} className="text-green-600" />
                    </div>
                </div>
                <div className="bg-gradient-to-r from-red-200 to-red-50 p-6 rounded-lg flex items-start w-full justify-between ">
                    <div>
                        <h3 className="text-xl text-gray-600 mb-2">Total Expenses</h3>
                        <p className="text-[20px] font-semibold text-red-600">
                            {`Kes. ${financialData?.general_financial_reports?.totalExpenses?.toLocaleString()}` || 'No data available'}
                        </p>
                    </div>
                    <div className="bg-red-200 p-2 rounded-full border border-red-500">
                        <FaMoneyBillAlt size={24} className="text-red-600" />
                    </div>
                </div>
                <div className="bg-gradient-to-r from-blue-200 to-blue-50 p-6 rounded-lg flex items-start w-full justify-between ">
                    <div>
                        <h3 className="text-xl text-gray-600 mb-2">Profit</h3>
                        <p className="text-[20px] font-semibold text-blue-600">
                            {`Kes. ${financialData?.general_financial_reports?.profit?.toLocaleString()}`}
                        </p>
                    </div>
                    <div className="bg-blue-200 p-2 rounded-full border border-blue-500">
                        <FaArrowUp size={24} className="text-blue-600" />
                    </div>
                </div>
                <div className="bg-gradient-to-r from-teal-200 to-teal-50 p-6 rounded-lg flex items-start w-full justify-between ">
                    <div>
                        <h3 className="text-xl text-gray-600 mb-2">Loss</h3>
                        <p className="text-[20px] font-semibold text-gray-500">
                            {`Kes. ${financialData?.general_financial_reports?.loss?.toLocaleString()}`}
                        </p>
                    </div>
                    <div className="bg-teal-200 p-2 rounded-full border border-teal-500">
                        <FaArrowDown size={24} className="text-gray-500" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FinancialReport;
